'use client';

import { Modal, useField, useModal, useTranslation } from '@payloadcms/ui';
import type { ViewDescriptionClientProps } from 'payload';
import * as React from 'react';
import { options } from '../../options';
import { CustomThemeDescriptionModal } from './CustomThemeDescriptionModal';

export const CustomThemeDescription: React.FC<ViewDescriptionClientProps> = ({ collectionSlug, description }) => {
  const { t } = useTranslation<any, any>();
  const { openModal, isModalOpen } = useModal();
  const field = useField();
  const modalId = `custom-theme-description-modal-${collectionSlug}`;
  const isModalOpened = isModalOpen(modalId);
  if (!options.defaultTheme) {
    return;
  }
  return (
    <div className={'custom-theme-description'}>
      <span>A json with the overrides of the default theme vars.</span>
      <button type="button"
        onClick={() => openModal(modalId)}
        className={'custom-theme-description-btn'}
      >
        <span>{t('llm:viewFullSpecs')}</span>
      </button>
      <Modal slug={modalId} className={'custom-theme-description__modal'}>
        {isModalOpened && (
          <CustomThemeDescriptionModal modalId={modalId} value={field.value} />
        )}
      </Modal>
    </div>
  );
};
